(function () {
  function initHolyProductTabs(root) {
    if (!root || root.dataset.holyTabsReady === 'true') return;
    root.dataset.holyTabsReady = 'true';

    const tabs = root.querySelectorAll('[data-holy-tab]');
    const panels = root.querySelectorAll('[data-holy-panel]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.holyTab;

        tabs.forEach((t) => {
          const active = t.dataset.holyTab === target;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const show = target === 'all' || panel.dataset.holyPanel === target;
          panel.hidden = !show;
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-holy-product-tabs]').forEach(initHolyProductTabs);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-holy-product-tabs]');
    if (root) initHolyProductTabs(root);
  });
})();
